import { Component, inject, signal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DashboardDialogFramePart, DialogAction, DialogContext, DialogService } from '@eforall/dashboard';
import { EditChartDialog } from '../edit-chart.dialog';
import { VegaService } from '../vega.service';


@Component({
	selector: 'view-charts-dialog',
	standalone: true,
	imports: [
		DashboardDialogFramePart,
	],
	templateUrl: './view-charts.dialog.html',
	styleUrl: './view-charts.dialog.scss',
})

export class ViewChartsDialog {

	public dialogRef = inject(MatDialogRef<ViewChartsDialog>);
	public dialogContext: DialogContext<{}> = inject(MAT_DIALOG_DATA);

	private dialogService = inject(DialogService);
	private vegaService = inject(VegaService);


	public actions: DialogAction[] = [
		{
			id: 'edit',
			cssClass: signal(undefined),
			enabled: signal(true),
			visible: signal(true),
			text: signal('Edit'),
			linkType: 'no-action',
			willCloseDialog: false,
		},
		{
			id: 'delete',
			cssClass: signal(undefined),
			enabled: signal(true),
			visible: signal(true),
			text: signal('Delete'),
			linkType: 'no-action',
			willCloseDialog: false,
		},
		{
			id: 'close',
			cssClass: signal(undefined),
			enabled: signal(true),
			visible: signal(true),
			text: signal('Close'),
			linkType: 'no-action',
			willCloseDialog: true,
		},
	];


	public async addChart() {
		const action = await this.dialogService.showCustom(EditChartDialog, { data: { chartId: 652 } }, 2000, 2000);
	}

}